/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { userService } from "../../../api/services/userService";
import { setEmployeeCompanyData } from "../../../infra/aggregates/employeeCompanySlice";
import { useAppSelector, useAppDispatch } from "../../../infra/hooks";

interface PropsValue {
  setEmpNameDesignation: (data: any) => void;
}
function DTOSalary({ setEmpNameDesignation }: PropsValue) {
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  const stored_companyLogo = useAppSelector(
    (state) => state.employeeCompanySlice.logo
  );
  const getCompanyLogo = () => {
    if (!stored_companyLogo && selector.authSlice.company_id > 0) {
      userService
        .getCompanDetail(selector.authSlice.company_id)
        .then((response: any) => {
          console.log("DTO Salary");

          dispatch(setEmployeeCompanyData({ logo: response?.data?.logo }));
        })
        .catch((err) =>
          console.log(
            "Error while getting company detail in DTO Salary component",
            err
          )
        );
    }
  };

  useEffect(() => {
    getCompanyLogo();
  }, []);
  useEffect(() => {
    setEmpNameDesignation({
      name:
        selector?.personalInfoSlice?.firstName +
        " " +
        selector?.personalInfoSlice?.lastName,
      designation: selector?.authSlice?.designaion,
    });
  }, [selector?.personalInfoSlice?.firstName, selector?.authSlice?.designaion]);
  return <></>;
}
export default DTOSalary;
